import styled from 'styled-components'
import theme from './theme'
import React from 'react'
import Icon from './Icon'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  height: 100%;
  color: ${ theme.palette.black };
  > svg {
    width: 80px;
    height: 80px;
  }
`


function LoadingPage({...props}) {
  return <Container>
    <Icon name='loading'/>
  </Container>
}

export default LoadingPage
